/* LATTICE · pixel lens. Desktop fine pointer: viewfinder lens (×2.5) over gallery IMAGES; click/tap = branded lightbox
   (drag/scroll pan, zoom toggle, pinch + double-tap on touch, swipe/arrow prev-next, Esc, focus trap).
   Video slides are skipped entirely. No work until first hover/tap; one delegated listener set; nothing per-frame when idle. */
(function () {
  'use strict';
  if (window.__pixelLens) return; window.__pixelLens = 1;
  var Z = 2.5, BOX_Z = 2.5;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hiCache = Object.create(null);
  function hi(src) { if (!hiCache[src]) { var i = new Image(); i.decoding = 'async'; i.src = src; hiCache[src] = i; } return hiCache[src]; }
  function item(t) { var it = t && t.closest ? t.closest('.product__media-item') : null; var o = it && it.querySelector('[data-pl-src]'); if (!o) return null; it.dataset.plSrc = o.dataset.plSrc; it.dataset.plAlt = o.dataset.plAlt || ''; return it; }
  function shownImg(it) { return it.querySelector('.product__media img'); }
  // rendered box of an object-fit:contain image inside its element
  function imgBox(img) {
    var r = img.getBoundingClientRect(), nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
    var fit = getComputedStyle(img).objectFit, w = r.width, h = r.height;
    if (fit === 'contain' && nw && nh) { var s = Math.min(r.width / nw, r.height / nh); w = nw * s; h = nh * s; }
    else if (fit === 'cover' && nw && nh) { var c = Math.max(r.width / nw, r.height / nh); w = nw * c; h = nh * c; }
    return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
  }

  /* ---------------- lens (desktop) ---------------- */
  var lens, lensImg, lensRead, lensItem = null, raf = 0, px = 0, py = 0;
  function buildLens() {
    lens = document.createElement('div'); lens.className = 'pl-lens'; lens.setAttribute('aria-hidden', 'true');
    lens.innerHTML = '<img class="pl-lens__img" alt=""><span class="pl-lens__grid"></span><span class="pl-lens__corner pl-lens__corner--tl"></span><span class="pl-lens__corner pl-lens__corner--tr"></span><span class="pl-lens__corner pl-lens__corner--bl"></span><span class="pl-lens__corner pl-lens__corner--br"></span><span class="pl-lens__cross"></span><span class="pl-lens__hud"><span>×' + Z + '</span><span class="pl-lens__xy">x 000 · y 000</span></span>';
    lensImg = lens.firstChild; lensRead = lens.querySelector('.pl-lens__xy');
  }
  function lensOn(it) {
    if (!lens) buildLens();
    lensItem = it; it.classList.add('pl-on');
    var host = it;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(lens);
    var src = it.dataset.plSrc, img = shownImg(it);
    lensImg.src = (img && (img.currentSrc || img.src)) || src; // instant low-res, swap to hi-res when decoded
    lens.classList.add('is-loading');
    var h = hi(src);
    var swap = function () { if (lensItem === it) { lensImg.src = src; lens.classList.remove('is-loading'); } };
    if (h.complete && h.naturalWidth) swap(); else h.addEventListener('load', swap, { once: true });
    lens.classList.add('is-on');
  }
  function lensOff() {
    if (!lensItem) return;
    lensItem.classList.remove('pl-on'); lensItem = null;
    if (lens) { lens.classList.remove('is-on'); if (lens.parentNode) lens.parentNode.removeChild(lens); }
    if (raf) { cancelAnimationFrame(raf); raf = 0; }
  }
  function lensPaint() {
    raf = 0; if (!lensItem) return;
    var img = shownImg(lensItem); if (!img) return lensOff();
    var host = lens.parentNode.getBoundingClientRect(), b = imgBox(img);
    if (px < b.left || px > b.left + b.width || py < b.top || py > b.top + b.height) { lens.classList.remove('is-on'); return; }
    lens.classList.add('is-on');
    var size = lens.offsetWidth, half = size / 2;
    var lx = Math.min(Math.max(px - host.left - half, 0), host.width - size), ly = Math.min(Math.max(py - host.top - half, 0), host.height - size);
    lens.style.transform = 'translate3d(' + lx + 'px,' + ly + 'px,0)';
    var rx = (px - b.left) / b.width, ry = (py - b.top) / b.height;
    lensImg.style.width = b.width + 'px'; lensImg.style.height = b.height + 'px';
    var cx = (px - host.left) - lx, cy = (py - host.top) - ly; // cursor inside lens
    lensImg.style.transform = 'translate3d(' + (cx - rx * b.width * Z) + 'px,' + (cy - ry * b.height * Z) + 'px,0) scale(' + Z + ')';
    lensImg.style.imageRendering = (b.width * Z / (lensImg.naturalWidth || 1e9)) > 1.001 ? 'pixelated' : 'auto';
    var nw = img.naturalWidth || 1000, nh = img.naturalHeight || 1000;
    lensRead.textContent = 'x ' + String(Math.round(rx * nw)).padStart(4, '0') + ' · y ' + String(Math.round(ry * nh)).padStart(4, '0');
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || !FINE.matches) return;
    if (e.target.closest && e.target.closest('.pl-hint')) { lensOff(); return; } /* never cover the zoom hint */
    var it = item(e.target);
    if (it !== lensItem) { lensOff(); if (it && !document.querySelector('.pl-box.is-open')) lensOn(it); }
    if (!lensItem) return;
    px = e.clientX; py = e.clientY;
    if (RM.matches) lensPaint(); else if (!raf) raf = requestAnimationFrame(lensPaint);
  }, { passive: true });
  document.addEventListener('pointerleave', lensOff);
  window.addEventListener('scroll', function () { if (lensItem) lensOff(); }, { passive: true });

  /* ---------------- lightbox ---------------- */
  var box, stage, bimg, countEl, zoomRead, foot, list = [], idx = 0, lastFocus = null;
  var sc = 1, tx = 0, ty = 0, base = 1, pointers = new Map(), drag = null, pinch = null, lastTap = 0;
  var PIX_X = '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" d="M1 1h2v2H1zM3 3h2v2H3zM5 5h2v2H5zM7 3h2v2H7zM9 1h2v2H9zM3 7h2v2H3zM1 9h2v2H1zM7 7h2v2H7zM9 9h2v2H9z"/></svg>';
  var PIX_L = '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" d="M7 1h2v2H7zM5 3h2v2H5zM3 5h2v2H3zM5 7h2v2H5zM7 9h2v2H7z"/></svg>';
  var PIX_R = '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" d="M3 1h2v2H3zM5 3h2v2H5zM7 5h2v2H7zM5 7h2v2H5zM3 9h2v2H3z"/></svg>';
  var PIX_Z = '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" d="M3 0h4v1H3zM2 1h1v1H2zM7 1h1v1H7zM1 2h1v4H1zM8 2h1v4H8zM2 6h1v1H2zM7 6h1v1H7zM3 7h4v1H3zM8 8h1v1H8zM9 9h1v1H9zM10 10h1v1h-1zM4 3h2v1H4zM4.5 2.5h1v2h-1z"/></svg>';
  function buildBox() {
    box = document.createElement('div'); box.className = 'pl-box'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Image viewer');
    box.innerHTML = '<div class="pl-box__bg"></div><div class="pl-box__stage"><img class="pl-box__img" alt="" draggable="false"></div>' +
      '<span class="pl-box__corner pl-box__corner--tl"></span><span class="pl-box__corner pl-box__corner--tr"></span><span class="pl-box__corner pl-box__corner--bl"></span><span class="pl-box__corner pl-box__corner--br"></span>' +
      '<div class="pl-box__bar"><span class="pl-box__count" aria-live="polite"></span><span class="pl-box__zoomread lat-mono">×1</span>' +
      '<button type="button" class="pl-btn" data-pl="zoom" aria-label="Zoom in" aria-pressed="false">' + PIX_Z + '</button>' +
      '<button type="button" class="pl-btn" data-pl="close" aria-label="Close">' + PIX_X + '</button></div>' +
      '<button type="button" class="pl-btn pl-box__nav pl-box__nav--prev" data-pl="prev" aria-label="Previous image">' + PIX_L + '</button>' +
      '<button type="button" class="pl-btn pl-box__nav pl-box__nav--next" data-pl="next" aria-label="Next image">' + PIX_R + '</button>' +
      '<div class="pl-box__foot"></div>';
    document.body.appendChild(box);
    stage = box.querySelector('.pl-box__stage'); bimg = box.querySelector('.pl-box__img'); countEl = box.querySelector('.pl-box__count');
    zoomRead = box.querySelector('.pl-box__zoomread'); foot = box.querySelector('.pl-box__foot');
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pl]'); if (!b) return;
      var a = b.dataset.pl;
      if (a === 'close') close(); else if (a === 'prev') go(-1); else if (a === 'next') go(1); else if (a === 'zoom') toggleZoom();
    });
    document.addEventListener('keydown', function (e) { if (box.classList.contains('is-open')) onKey(e); });
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp); stage.addEventListener('pointercancel', onUp);
    stage.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('resize', function () { if (box.classList.contains('is-open')) fit(true); });
  }
  function collect(start) {
    var gallery = start.closest('media-gallery') || document;
    var seen = {}; list = [];
    gallery.querySelectorAll('.product__media-list .product__media-item').forEach(function (it) {
      if (it.hasAttribute('data-pp-off') || !item(it)) return; var k = it.dataset.plSrc; if (seen[k]) return; seen[k] = 1;
      var im = shownImg(it); list.push({ src: k, alt: it.dataset.plAlt || (im && im.alt) || '', el: it });
    });
    idx = Math.max(0, list.findIndex(function (x) { return x.src === start.dataset.plSrc; }));
  }
  function open(it, trig) {
    lensOff(); if (!box) buildBox();
    collect(it); lastFocus = trig || document.activeElement;
    document.documentElement.classList.add('pl-lock');
    box.classList.add('is-open'); show(); box.querySelector('[data-pl="close"]').focus();
  }
  function close() {
    box.classList.remove('is-open', 'is-zoomed'); document.documentElement.classList.remove('pl-lock');
    bimg.removeAttribute('src'); pointers.clear(); drag = pinch = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function show() {
    var cur = list[idx]; if (!cur) return;
    bimg.alt = cur.alt; foot.textContent = cur.alt;
    countEl.innerHTML = '<b>' + String(idx + 1).padStart(2, '0') + '</b> / ' + String(list.length).padStart(2, '0');
    var nav = list.length > 1; box.querySelectorAll('.pl-box__nav').forEach(function (n) { n.hidden = !nav; });
    var low = shownImg(cur.el); bimg.src = (low && (low.currentSrc || low.src)) || cur.src;
    var h = hi(cur.src), me = idx;
    var done = function () { if (me === idx && box.classList.contains('is-open')) { bimg.src = cur.src; fit(false); } };
    if (h.complete && h.naturalWidth) done(); else { h.addEventListener('load', done, { once: true }); bimg.onload = function () { bimg.onload = null; fit(false); }; }
    fit(false);
  }
  function go(d) { if (list.length < 2) return; idx = (idx + d + list.length) % list.length; show(); }
  function fit(keep) {
    var r = stage.getBoundingClientRect(), nw = bimg.naturalWidth || 1, nh = bimg.naturalHeight || 1;
    base = Math.min(r.width / nw, r.height / nh, 1e9);
    bimg.style.width = nw + 'px'; bimg.style.height = nh + 'px';
    if (!keep) { sc = 1; }
    center(); apply(false);
  }
  function center() { var r = stage.getBoundingClientRect(); var s = base * sc; tx = (r.width - bimg.naturalWidth * s) / 2; ty = (r.height - bimg.naturalHeight * s) / 2; }
  function clamp() {
    var r = stage.getBoundingClientRect(), s = base * sc, w = bimg.naturalWidth * s, h = bimg.naturalHeight * s;
    tx = w <= r.width ? (r.width - w) / 2 : Math.min(0, Math.max(r.width - w, tx));
    ty = h <= r.height ? (r.height - h) / 2 : Math.min(0, Math.max(r.height - h, ty));
  }
  function apply(anim) {
    clamp();
    box.classList.toggle('is-anim', !!anim && !RM.matches);
    bimg.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + (base * sc) + ')';
    bimg.style.imageRendering = base * sc > 1.001 ? 'pixelated' : 'auto'; /* blocky only when magnified past 1:1 */
    var z = sc > 1.01; box.classList.toggle('is-zoomed', z);
    var zb = box.querySelector('[data-pl="zoom"]'); var zmax = sc >= deepZ() - 0.05; zb.setAttribute('aria-pressed', z); zb.setAttribute('aria-label', zmax ? 'Zoom out' : 'Zoom in');
    zoomRead.textContent = '×' + (Math.round(sc * 10) / 10);
  }
  function zoomAt(ns, cx, cy, anim) {
    ns = Math.max(1, Math.min(ns, capZ())); var r = stage.getBoundingClientRect();
    var x = cx - r.left, y = cy - r.top, k = ns / sc; tx = x - (x - tx) * k; ty = y - (y - ty) * k; sc = ns; apply(anim);
  }
  function toggleZoom(cx, cy) {
    var r = stage.getBoundingClientRect();
    if (cx == null) { cx = r.left + r.width / 2; cy = r.top + r.height / 2; }
    /* B01A: steps ×1 → ×2.5 → print-reading depth (2 CSS px per image px, so small back-print equations read at 390) → ×1 */
    var dz = deepZ();
    if (sc < 1.01) zoomAt(Math.min(BOX_Z, dz), cx, cy, true);
    else if (sc < dz - 0.05) zoomAt(dz, cx, cy, true);
    else { sc = 1; center(); apply(true); }
  }
  // depth at which one image pixel spans 2 CSS px (never below ×BOX_Z); pinch may go to max(6, that)
  function deepZ() { return Math.max(BOX_Z, Math.min(2 / (base || 1), 12)); }
  function capZ() { return Math.max(6, deepZ()); }
  function onDown(e) {
    stage.setPointerCapture(e.pointerId); pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 2) {
      var p = Array.from(pointers.values()); pinch = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y), s: sc }; drag = null; return;
    }
    drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, moved: false, t: Date.now() };
  }
  function onMove(e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pinch && pointers.size === 2) {
      var p = Array.from(pointers.values()); var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      zoomAt(pinch.s * d / pinch.d, (p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2, false); return;
    }
    if (!drag) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 6) drag.moved = true;
    if (sc > 1.01) { box.classList.add('is-dragging'); tx = drag.tx + dx; ty = drag.ty + dy; apply(false); }
  }
  function onUp(e) {
    pointers.delete(e.pointerId); box.classList.remove('is-dragging');
    if (pinch) { if (pointers.size < 2) pinch = null; drag = null; return; }
    if (!drag) return;
    var d = drag; drag = null;
    var dx = e.clientX - d.x;
    if (!d.moved) {
      var now = Date.now();
      if (e.pointerType !== 'mouse') { if (now - lastTap < 300) { toggleZoom(e.clientX, e.clientY); lastTap = 0; } else lastTap = now; }
      else toggleZoom(e.clientX, e.clientY);
    } else if (sc <= 1.01 && Math.abs(dx) > 50 && Date.now() - d.t < 600) go(dx < 0 ? 1 : -1);
  }
  function onWheel(e) {
    e.preventDefault();
    if (e.ctrlKey || sc <= 1.01) { zoomAt(sc * Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.002)), e.clientX, e.clientY, false); return; }
    tx -= e.deltaX; ty -= e.deltaY; apply(false);
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') { if (sc > 1.01) { tx -= 60; apply(false); } else go(1); }
    else if (e.key === 'ArrowLeft') { if (sc > 1.01) { tx += 60; apply(false); } else go(-1); }
    else if (e.key === 'ArrowUp' && sc > 1.01) { ty += 60; apply(false); }
    else if (e.key === 'ArrowDown' && sc > 1.01) { ty -= 60; apply(false); }
    else if (e.key === '+' || e.key === '=') zoomAt(sc * 1.4, innerWidth / 2, innerHeight / 2, true);
    else if (e.key === '-') { zoomAt(sc / 1.4, innerWidth / 2, innerHeight / 2, true); }
    else if (e.key === 'Tab') {
      var f = Array.from(box.querySelectorAll('button:not([hidden])')); if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (i === f.length - 1 || i < 0)) { e.preventDefault(); f[0].focus(); }
    }
  }
  /* zoom hint: pulse once per session (never with reduced motion); stop after first use */
  function seen() { try { sessionStorage.setItem('plHintSeen', '1'); } catch (e) {} document.documentElement.classList.remove('pl-hint-pulse'); }
  (function () {
    var s = null; try { s = sessionStorage.getItem('plHintSeen'); } catch (e) {}
    if (s || RM.matches) return;
    document.documentElement.classList.add('pl-hint-pulse');
    try { sessionStorage.setItem('plHintSeen', '1'); } catch (e) {}
  })();
  // capture phase: beat Dawn's modal-opener so there is one viewer; video slides never match [data-pl]
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.product__media-toggle, .product__modal-opener--image img');
    if (!t) return; var it = item(t); if (!it) return;
    e.preventDefault(); e.stopImmediatePropagation(); seen();
    var hb = it.querySelector('.pl-hint'); open(it, t.classList.contains('pl-hint') ? t : (hb || t));
  }, true);
})();
